// Visitor session for one Trust Center slug (localStorage). Buyers are not
// Regodit users; the token is the opaque string from POST /api/public/trust/verify.

const keyFor = (slug) => `trustCenter.visitor.${String(slug || "").toLowerCase()}`;

export const readVisitorSession = (slug) => {
  try {
    const raw = localStorage.getItem(keyFor(slug));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.token || !parsed?.email) return null;
    if (parsed.expiresAt && Date.parse(parsed.expiresAt) <= Date.now()) {
      localStorage.removeItem(keyFor(slug));
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const writeVisitorSession = (slug, session) => {
  localStorage.setItem(
    keyFor(slug),
    JSON.stringify({
      token: session.token,
      email: session.email,
      expiresAt: session.expiresAt || null,
      // A grant link opens requestable files. Kept so the resource shows
      // View and Download before the page refetches.
      privateAccess: !!session.privateAccess,
    })
  );
};

export const clearVisitorSession = (slug) => {
  localStorage.removeItem(keyFor(slug));
};
